<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>问诊医生</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.key" placeholder="输入用户名/姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" @click="paibanVisible = true">排班</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" prop="uname" label="用户名" width="120">
      </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名" width="120">
      </el-table-column>
      <el-table-column align="center" prop="doctorid" label="医生ID" width="120">
      </el-table-column>
      <el-table-column align="center" prop="weeks" label="排班日期">
      </el-table-column>
      <el-table-column align="center" prop="pbtime" label="排班时间">
        <template slot-scope="scope">
          {{scope.row.stime}} - {{scope.row.etime}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editPaiban(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delPaiban(scope.row.id,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 排班弹窗 -->
    <el-dialog title="医生排班" width="700px" :visible.sync="paibanVisible" :close-on-click-modal="false">
      <el-form label-position="left" :model="formData" class="demo-form-inline" label-width="100px">
        <el-form-item label="用户" required>
          <el-input class="width300" v-model="formData.realname " placeholder="选择用户" disabled>
            <el-button slot="append" icon="el-icon-search" @click="dialogVisible = true"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="排班日期" required>
          <el-checkbox-group  v-model="changeweeks">
            <el-checkbox v-for="(item,index) in weeks" :label="item" :key="index"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="排班时间" required>
          <el-time-select
            placeholder="起始时间"
            v-model="formData.stime"
            :picker-options="{
              start: '08:00',
              step: '00:30',
              end: '18:00'
            }">
          </el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="formData.etime"
            :picker-options="{
              start: '08:00',
              step: '00:30',
              end: '18:00',
              minTime: formData.stime
            }">
          </el-time-select>
        </el-form-item>
        <el-form-item label="启/停">
          <el-switch
            v-model="formData.is_start"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="paibanVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit_pb">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择用户弹窗 -->
    <el-dialog title="选择用户" width="500px" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <changeuser utype="1" @changeuser="setuser" @close_changeuser="close_changeuser"></changeuser>
    </el-dialog>

  </div>
</template>

<script>
  import { paibanList,wzpaiban,delPaiban } from '../../api/baseset'
  import Pagination from '../../components/Pagination'
  import changeuser from '../../components/changeuser.vue';
  export default {
    data() {
      return {
        loading: false,
        dialogVisible: false,
        paibanVisible: false,
        weeks: ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
        changeweeks: [],
        formData: {
          is_start: '1',
          weeks: [],
          stime: '',
          etime: ''
        },
        listData: [],
        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          key: ''
        },
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    created() {
      this.getdata(this.formInline)
    },
    components: {
      Pagination,
      changeuser
    },
    methods: {
      // 获取数据方法
      getdata(parameter) {
        this.loading = true
         paibanList(parameter).then(res => {
           this.loading = false
           if (res.code != 0) {
             this.$message({
               type: 'info',
               message: res.msg
             })
           } else {
             this.listData = res.data.list
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.data.count
           }
         })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      setuser(user) {
        this.formData.uid = user.id
        this.formData.uname = user.uname
        this.formData.realname = user.realname
        this.formData.doctorid = user.doctorid
      },
      close_changeuser() {
        this.dialogVisible = false
      },
      //搜索事件
      search() {
        this.formInline.page = 1
        this.formInline.limit = 10
        this.getdata(this.formInline)
      },
      submit_pb() {
        if(this.formData.uid == undefined){
          this.$message.error('请选择用户')
          return
        }
        if(this.changeweeks.length === 0){
          this.$message.error('请选择排班日期')
          return
        }
        if(this.formData.stime == '' || this.formData.etime == ''){
          this.$message.error('请选择排班时间')
          return
        }
        this.formData.weeks = this.changeweeks.splice(',')
        wzpaiban(this.formData).then(res => {
          if(res.code == 0){
            this.formData = {
              is_start: '1',
              weeks: [],
              stime: '',
              etime: ''
            }
            this.paibanVisible = false
            this.getdata(this.formInline)
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      editPaiban(row) {
        this.paibanVisible = true
        this.changeweeks = row.weeks.split(',')
        this.formData = row
        this.formData.is_start = row.is_start.toString()
      },
      delPaiban(id,index) {
        this.$confirm('您确定要删除此信息吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPaiban({id:id}).then(res => {
            if(res.code == 0){
              this.listData.splice(index,1)
            }else{
              this.$message.error(res.msg)
            }
          })
        })
      }
    }
  }
</script>

<style>
.user-search {
  margin-top: 20px;
}
.el-input.is-disabled .el-input__inner{background-color: #FFFFFF!important;color: #666666;}
</style>



// WEBPACK FOOTER //
// src/views/wenzhen/paiban.vue